import script from "./CabinetLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./CabinetLogin.vue?vue&type=script&setup=true&lang=js"

import "./CabinetLogin.vue?vue&type=style&index=0&id=5fb53be2&lang=css"

const __exports__ = script;

export default __exports__